module.exports = __webpack_public_path__ + "img/pressreader_en.bd1411df.jpg";